import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../app.environments';

export function setAuthToken(token: string): void {
  localStorage.setItem('auth_token', token);
}

export function getAuthToken(): string | null {
  return localStorage.getItem('auth_token');
}

export function getAuthHeaders(): HttpHeaders {
  const token = getAuthToken();
  return new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  });
}

export function isCategoriesApiUrl(url: string): boolean {
  // Check for both production and localhost URLs
  //return url.includes('/elixrposapi-dev.vprc.in/api') || url.includes('/posapi.elixrretailpos.com/api') || url.includes('localhost:5100/api/v1') || url.includes('127.0.0.1:5100/api/v1');
  return url.includes(environment.authURL)
}
